import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  createStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FaqModel from "../../../core/models/Faq";
import { EVENT_FAQ_OPEN_ALL, EVENT_FAQ_CLOSE_ALL } from "../../../Events";
import { useHubXSubscribe } from "../../../HubX";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "margin": theme.spacing(2, 0),

      "& .MuiAccordionDetails-root": {
        padding: theme.spacing(1, 0),
      },
      "& > .MuiAccordionSummary-root": {
        fontSize: "1rem",
        background: theme.customPaper.background.cardBackgroundLight,
        //maxHeight: "48px",
        //minHeight: "48px",
        // color: theme.palette.common.white
        fontWeight: "bold",
        borderBottom: theme.palette.type == "dark" ? "2px solid #565555 " : "transparent"
      },

      "& > .Mui-expanded": {
        "background": theme.customPaper.background.cardBackground,
        "color": theme.palette.common.white,
        "fontWeight": "bold",

        "& .icon": {
          color: theme.palette.common.white,
        },
      },
    },

    cardWrapper: {
      display: "flex",
      flexWrap: "wrap",
      padding: theme.spacing(2),
      columnGap: theme.spacing(4),
      rowGap: `${theme.spacing(3)}px`,
      [theme.breakpoints.between("sm", "md")]: {
        justifyContent: "center",
      },
    },

    tableWrapper: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      flex: "1 1",
    },

    disablePaddingBottom: {
      "& .MuiAccordionDetails-root": {
        padding: theme.spacing(1, 0, 0, 0),
      },
    },

    hidden: {
      display: "none",
    },
  })
);

type FaqAccordionItemProps = {
  faq: FaqModel;
  startOpen?: boolean;
};

function FaqAccordionItem({ faq, startOpen }: FaqAccordionItemProps) {
  const [expanded, setExpanded] = React.useState(() => {
    return startOpen || false;
  });

  useHubXSubscribe(EVENT_FAQ_OPEN_ALL, () => setExpanded(true));
  useHubXSubscribe(EVENT_FAQ_CLOSE_ALL, () => setExpanded(false));

  const classes = useStyles();
  return (
    <Accordion
      className={classes.root}
      elevation={0}
      expanded={expanded}
      onChange={() => setExpanded((prev) => !prev)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="large" className={"icon"} />}>
        {faq.question}
      </AccordionSummary>

      <AccordionDetails>
        <div className={classes.cardWrapper}>
          <div className={classes.tableWrapper}>
            <Typography>
              <div dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
            </Typography>
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
}

export default FaqAccordionItem;
